export default __webpack_public_path__ + "static/iso-2cb80665f2004a1b3c4bf25fae1ef95c.png";